import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterItem,
  CharacterBasicItem,
  // CharacterAmmunition,
  Armor,
  BasicItem,
  CharacterWeapon,
  CharacterContainer,
  CharacterArmor,
  CharacterReceivable,
  CharacterCustomItem,
  CharacterAmmunition,
  CharacterGem,
  CharacterReceivableItem,
} from "@dndModels";
import { AttackType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
// import StringBox from '../../../../../components/input/strings/StringBox';

import SelectStringBox from "@components/input/selects/SelectStringBox";
import DandDButtonBox from "@dndComponents/DandDButtonBox";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

interface Props {
  character: Character;
  char_item: CharacterItem;
  onChange: (repopulate: boolean, close: boolean) => void;
  onSelling: () => void;
  onBuying: () => void;
  onRemove: () => void;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function CharacterItemOptionControls({
  character,
  char_item,
  onChange,
  onSelling,
  onBuying,
  onRemove
}: Props) {
  const [ping, setPing] = useState(false);
  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [give_count, setGiveCount] = useState(1);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // margin: "4px",
        backgroundColor: theme.palette.secondary.main
      },
    });
  });
  
  const { classes, cx } = useStyles();
  
  const renderCharacters = () => {
    const campaign = character.campaign;
    if (campaign) {
      return campaign.characters.filter(o => o.active && !o.is_archived && o._id !== character._id).map(char => {
        return (
          <Grid key={char._id} size={{
            xs: 12
          }}>
            <div className="padded">
              <Grid container spacing={0} direction="row" className={cx(classes.root, "padded")}>
                <Grid
                  size={{
                    xs: 9
                  }}>
                  { char.name }
                </Grid>
                <Grid
                  size={{
                    xs: 3
                  }}>
                  <DandDButtonBox 
                    name="Give"
                    disabled={processing}
                    onClick={() => {
                      const receivable = new CharacterReceivable();
                      receivable.from_id = character._id;
                      receivable.char_id = char._id;
                      receivable.sent_dt = common_util.get_time_number();
                      receivable.items = [new CharacterReceivableItem({
                        type: "Item",
                        obj_id: char_item._id,
                        count: give_count,
                      })];
                      char.subscription_holder.itemsChanged();
                      char.changed();
                      if (char_item instanceof CharacterBasicItem || 
                        char_item instanceof CharacterCustomItem || 
                        char_item instanceof CharacterAmmunition ||
                        char_item instanceof CharacterWeapon || 
                        char_item instanceof CharacterGem) {
                        char_item.count -= give_count;
                        setProcessing(true);
                        api.upsertObject("character_receivable", receivable).then(res => {
                          setProcessing(false);
                          if (char_item.count <= 0) {
                            setOpen(false);
                            onRemove();
                          }
                        });
                      } else {
                        setProcessing(true);
                        api.upsertObject("character_receivable", receivable).then(res => {
                          setProcessing(false);
                          connect_util.removeItem(character, char_item);
                          setOpen(false);
                          onRemove();
                        });
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
        );
      });
    }
    return null;
  }
  
  const renderExtras = () => {
    const count_options: string[] = [];
    for (let i = 0; i < char_item.count; ++i) {
      count_options.push(`${i + 1}`);
    }
    return (
      <ModalOrDrawer 
        open={ open } 
        full_page
        onClose={() => {
          setOpen(false);
          character.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row" 
            style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              className="header centered"
              size={{
                xs: 12
              }}>
              { `Give ${char_item.name} to Allies` }
            </Grid>
            { char_item.count > 1 && 
              <Grid
                size={{
                  xs: 12
                }}>
                <SelectStringBox
                  name="Count"
                  options={count_options}
                  value={`${give_count}`}
                  onChange={(changed: string) => {
                    setGiveCount(+give_count);
                  }}
                />
              </Grid>
            }
            { renderCharacters() }
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign !== null && character.campaign.owner_id === api.user._id));

  const can_equip = char_util.canEquip(character, char_item);
  const can_attune = char_util.canAttune(character, char_item);
  // debugger;
  if (char_item instanceof CharacterBasicItem) {
    return (
      <Grid container spacing={0} direction="row">
        { (char_item.item_type === "Potion" || 
            char_item.item_type === "Scroll" || 
            char_item.item_type === "Dust" || 
            (char_item.base_item && 
              char_item.base_item instanceof BasicItem && 
              char_item.base_item.worn_type !== "None")) &&
          <Grid
            size={{
              xs: char_item.attunement ? 4 : 6
            }}>
            <ToggleButtonBox 
              name="Equipped"
              value={char_item.equipped}
              matchButtonBox
              tooltip={
                !can_equip ? 
                "You are not proficient in this item" : 
                ""
              }
              // style={{
              //   width: "100px",
              //   height: "20px",
              //   fontSize: "8px",
              //   lineHeight: "2.7"
              // }}
              disabled={ !char_item.equipped && (!can_equip || (char_item.base_item !== null && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name === "Shield" && character.shield_carried) || (char_item.base_item !== null && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name !== "Shield" && character.armor_worn)) }
              onToggle={() => {
                if (char_item.equipped) {
                  connect_util.unequipItem(character, char_item);
                } else {
                  connect_util.equipItem(character, char_item);
                }
                onChange(true, false);
                setPing(!ping);
              }}
            />
          </Grid>
        }
        { char_item.attunement &&
          <Grid
            size={{
              xs: 4
            }}>
            <ToggleButtonBox 
              name={ char_item.attuned ? "Attuned" : "Attune" }
              tooltip={can_attune === "true" ? "" : can_attune}
              value={char_item.attuned}
              matchButtonBox
              disabled={ !enabled || (!char_item.attuned && (character.attuned_items.length >= character.max_attuned_items || can_attune !== "true")) }
              onToggle={() => {
                if (char_item.attuned) {
                  connect_util.unattuneItem(character, char_item);
                } else {
                  connect_util.attuneItem(character, char_item);
                }
                character.changed();
                character.subscription_holder.recalculate();
                setPing(!ping);
              }}
            />
          </Grid>
        }
        <Grid
          size={{
            xs: char_item.attunement ? 4 : 6
          }}>
          <ButtonBox 
            name="Remove"
            disabled={ !enabled }
            onClick={() => {
              connect_util.removeItem(character, char_item);
              onRemove();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Sell"
            disabled={ !enabled }
            onClick={() => {
              onSelling();
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Buy More"
            disabled={ !enabled }
            onClick={() => {
              onBuying();
            }}
          />
        </Grid>
        { character.campaign &&
          <Grid
            size={{
              xs: 12
            }}>
            <DandDButtonBox
              name="Give to Ally"
              disabled={ !enabled }
              onClick={() => {
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
        }
      </Grid>
    );
  } else if (char_item instanceof CharacterContainer) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 4
          }}>
          <ButtonBox 
            name="Remove"
            disabled={ !enabled }
            onClick={() => {
              connect_util.removeItem(character, char_item);
              onRemove();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <ButtonBox 
            name="Remove All Contents"
            // height={20}
            style={{                  
              fontSize: "8px",
              lineHeight: "2.7"
            }}
            disabled={ !enabled }
            onClick={() => {
              for (const sub_item of character.items.filter(o => o.in_char_container_id === char_item.true_id)) {
                connect_util.removeItem(character, sub_item);
              }
              onChange(true, true);
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          <ButtonBox 
            name="Sell"
            disabled={ !enabled }
            onClick={() => {
              onSelling();
            }}
          />
        </Grid>
        { character.campaign &&
          <Grid
            size={{
              xs: 12
            }}>
            <DandDButtonBox
              name="Give to Ally"
              disabled={ !enabled }
              onClick={() => {
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
        }
      </Grid>
    );
  } else if (char_item instanceof CharacterWeapon) {
    const attack_types = char_item.base_item ? char_item.base_item.the_attack_types : [];
    // debugger;
    const { weapon_keywords } = char_util.getWeaponKeywordsForWeapon(character, char_item);
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 6
          }}>
          <ToggleButtonBox 
            name="Equipped"
            tooltip={
              !can_equip ? 
              "You are not proficient in this item" :
              ""
            }
            value={char_item.equipped}
            disabled={ !enabled || (!char_item.equipped && !can_equip) }
            matchButtonBox
            onToggle={() => {
              if (char_item.equipped) {
                connect_util.unequipItem(character, char_item);
              } else {
                connect_util.equipItem(character, char_item);
              }
              onChange(true, false);
              setPing(!ping);
            }}
          />
        </Grid>
        { attack_types.length > 1 &&
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox 
              name="Attack Types"
              options={attack_types}
              values={char_item.using_attack_types}
              multiple
              disabled={ !enabled || (!char_item.equipped && !can_equip) }
              onChange={(changed: AttackType[]) => {
                char_item.using_attack_types = changed;
                char_util.repopulateCharFeatureBases(character);
                onChange(true, false);
                setPing(!ping);
              }}
            />
          </Grid>
        }
        { weapon_keywords.find(o => o.name === "Light") &&
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox 
              name="Equipped Hand"
              options={["Any","Main","Off"]}
              value={char_item.equipped_hand}
              disabled={ !enabled || (!char_item.equipped && !can_equip) }
              onChange={(changed: string) => {
                char_item.equipped_hand = changed;
                onChange(true, false);
                setPing(!ping);
              }}
            />
          </Grid>
        }
        { char_item.attunement &&
          <Grid
            size={{
              xs: 6
            }}>
            <ToggleButtonBox 
              name={ char_item.attuned ? "Attuned" : "Attune" }
              tooltip={ can_attune === "true" ? "" : can_attune }
              value={char_item.attuned}
              matchButtonBox
              disabled={ !enabled || (!char_item.attuned && (character.attuned_items.length >= character.max_attuned_items || can_attune !== "true")) }
              onToggle={() => {
                if (char_item.attuned) {
                  connect_util.unattuneItem(character, char_item);
                } else {
                  connect_util.attuneItem(character, char_item);
                }
                character.changed();
                character.subscription_holder.recalculate();
                setPing(!ping);
              }}
            />
          </Grid>
        }
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Remove"
            disabled={ !enabled }
            onClick={() => {
              connect_util.removeItem(character, char_item);
              onRemove();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Sell"
            disabled={ !enabled }
            onClick={() => {
              onSelling();
            }}
          />
        </Grid>
        { character.campaign &&
          <Grid
            size={{
              xs: 12
            }}>
            <DandDButtonBox
              name="Give to Ally"
              disabled={ !enabled }
              onClick={() => {
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
        }
      </Grid>
    );
  } else if (char_item instanceof CharacterArmor) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 6
          }}>
          <ToggleButtonBox 
            name="Equipped"
            value={char_item.equipped}
            tooltip={
              !can_equip ? 
              "You are not proficient in this item" : 
              ((char_item.base_item && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name === "Shield" && character.shield_carried) ? 
                "You already have a Shield equipped" : 
                ((char_item.base_item && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name !== "Shield" && character.armor_worn) ? 
                  "You already have Armor equipped": ""
                )
              )
            }
            matchButtonBox
            disabled={ !char_item.equipped && (!can_equip || (char_item.base_item !== null && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name === "Shield" && character.shield_carried) || (char_item.base_item !== null && char_item.base_item instanceof Armor && char_item.base_item.armor_type_name !== "Shield" && character.armor_worn)) }
            onToggle={() => {
              if (char_item.equipped) {
                connect_util.unequipItem(character, char_item);
              } else {
                connect_util.equipItem(character, char_item);
              }
              onChange(true, false);
              setPing(!ping);
            }}
          />
        </Grid>
        { char_item.attunement &&
          <Grid
            size={{
              xs: 6
            }}>
            <ToggleButtonBox 
              name={ char_item.attuned ? "Attuned" : "Attune" }
              tooltip={ can_attune === "true" ? "" : can_attune }
              value={char_item.attuned}
              matchButtonBox
              disabled={ !enabled || (!char_item.attuned && (character.attuned_items.length >= character.max_attuned_items || can_attune !== "true")) }
              onToggle={() => {
                if (char_item.attuned) {
                  connect_util.unattuneItem(character, char_item);
                } else {
                  connect_util.attuneItem(character, char_item);
                }
                onChange(true, false);
                setPing(!ping);
              }}
            />
          </Grid>
        }
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Remove"
            disabled={ !enabled }
            onClick={() => {
              connect_util.removeItem(character, char_item);
              onRemove();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Sell"
            disabled={ !enabled }
            onClick={() => {
              onSelling();
            }}
          />
        </Grid>
        { character.campaign &&
          <Grid
            size={{
              xs: 12
            }}>
            <DandDButtonBox
              name="Give to Ally"
              disabled={ !enabled }
              onClick={() => {
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
        }
      </Grid>
    );
  } else {
    return (
      <Grid container spacing={0} direction="row">
        { char_item.attunement &&
          <Grid
            size={{
              xs: 6
            }}>
            <ToggleButtonBox 
              name={ char_item.attuned ? "Attuned" : "Attune" }
              tooltip={ can_attune === "true" ? "" : can_attune }
              value={char_item.attuned}
              matchButtonBox
              disabled={ !enabled || (!char_item.attuned && (character.attuned_items.length >= character.max_attuned_items || can_attune !== "true")) }
              onToggle={() => {
                if (char_item.attuned) {
                  connect_util.unattuneItem(character, char_item);
                } else {
                  connect_util.attuneItem(character, char_item);
                }
                character.changed();
                character.subscription_holder.recalculate();
                setPing(!ping);
              }}
            />
          </Grid>
        }
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Remove"
            disabled={ !enabled }
            onClick={() => {
              connect_util.removeItem(character, char_item);
              onRemove();
              setPing(!ping);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Sell"
            disabled={ !enabled }
            onClick={() => {
              onSelling();
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <ButtonBox 
            name="Buy More"
            disabled={ !enabled }
            onClick={() => {
              onBuying();
            }}
          />
        </Grid>
        { character.campaign &&
          <Grid
            size={{
              xs: 12
            }}>
            <DandDButtonBox
              name="Give to Ally"
              disabled={ !enabled }
              onClick={() => {
                setOpen(true);
              }}
            />
            { renderExtras() }
          </Grid>
        }
      </Grid>
    );
  }
}
